<template>
  <v-img
    src="../assets/eventlogo.png"
    max-width="1280px"
    class="ma-auto w-100 w-md-80"
  >
    <template #sources>
      <source srcset="../assets/eventlogo.webp" />
    </template>
  </v-img>
  <div>
    <p class="catch text-h4 text-md-h3">ご来場ありがとうございました！</p>
  </div>

  <v-btn
    size="x-large"
    variant="flat"
    block
    rounded="sm"
    href="http://d-mebius.com/fusigi_na_game2/"
    color="indigo"
    height="128"
    class="text-center"
    >2024/2/25(sun)開催予定<br />第二回 ふしぎなゲーム祭り サイトはこちら</v-btn
  >
</template>
<style scoped>
  .catch {
    text-align: center;
    font-family: "rocknroll-one", sans-serif !important;
    font-weight: bold;
    font-style: normal;
    margin: 30px auto;
    color: #4caf50;
    text-shadow: 0.04em 0.02em 0 #fff, 0.08em 0.05em 0 #69f0ae;
  }
</style>
